// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

/**
 * Language Identification mode
 * @class LanguageIdMode
 */
export enum LanguageIdMode {

    /**
     * Detect language at audio start
     * @member LanguageIdMode.AtStart
     */
    AtStart,

    /**
     * Continuously detect language
     * @member LanguageIdMode.Continuous
     */
    Continuous,
}
